import React from 'react';
import { ErrorResponse } from '@apollo/client/link/error';
import { ErrorToast } from 'components/ErrorToast';
import { toast } from 'react-toastify';
import authService from 'services/cognito/lib';
import { LocalStorageKey, removeItem } from 'services/persistentData';

const ignoreError = (graphQLError: any) => {
  return graphQLError.path && graphQLError.path.includes('getTemporaryCode');
};

const onError = (error: ErrorResponse) => {
  if (error.graphQLErrors) {
    const uniqueErrors = Array.from(
      new Map(
        error.graphQLErrors
          .filter((err) => !ignoreError(err))
          .map((err) => [err.message, err])
      ).values()
    );
    uniqueErrors.forEach((graphQLError) => {
      const message = graphQLError.message;
      switch (message) {
        case 'EXPIRED_AUTH':
          break;
        case 'AUTH_REQUIRED':
        case 'INVALID_AUTH':
        case 'FORBIDDEN':
          authService.logout({
            cleanSessionInfoCallback: () => {
              removeItem(LocalStorageKey.ACCESS_TOKEN);
            },
          });
          break;
        case 'OUT_OF_STOCK':
          toast(<ErrorToast errorMessage="OUT_OF_STOCK" />);
          break;
        case 'ORDER_GROUP_VALIDATION_ERROR':
          console.error('graphQLError', graphQLError);
          toast(<ErrorToast errorMessage="ERROR_VALIDATING_ORDER_GROUP" />);
          break;
        default:
          console.error('graphQLError', graphQLError);
          toast(<ErrorToast errorMessage="ERROR" />);
          break;
      }
    });
  }
};

export default { onError };
